import { render, staticRenderFns } from "./AccountManage.vue?vue&type=template&id=a50134cc&scoped=true&name=component-name&"
import script from "./AccountManage.vue?vue&type=script&lang=js&"
export * from "./AccountManage.vue?vue&type=script&lang=js&"
import style0 from "./AccountManage.vue?vue&type=style&index=0&id=a50134cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50134cc",
  null
  
)

export default component.exports